import { cart } from './cart';
import { collection } from './collections';
import { dialog } from './dialog';
import { search } from './search';

export default (Alpine) => {
  Alpine.store('cart', cart);
  Alpine.store('collection', collection);
  Alpine.store('dialog', dialog);
  Alpine.store('search', search);
};
